<div *ngIf="!finish" class="c-card c-card--notitle c-create-news">
    <div class="c-card__title mb-4">
        {{ ((this.isModel) ? 'CATEGORIES.ACTUALITES.ETAPE.TITRE.MODEL' : 'CATEGORIES.ACTUALITES.ETAPE.TITRE.ACTUALITE') | translate }}
    </div>

    <ul class="galec-etapier mt-2 mt-lg-3 pb-5 pb-lg-0">
        <li class="galec-etapier__item {{activeClass(1)}}">
            <span class="galec-etapier__number">1</span>
            <span class="galec-etapier__titre">{{ 'CATEGORIES.ACTUALITES.ETAPE.UN' | translate }}</span>
        </li>
        <li class="galec-etapier__item {{activeClass(2)}}">
            <span class="galec-etapier__number">2</span>
            <span class="galec-etapier__titre">{{ ((this.isModel) ? 'CATEGORIES.ACTUALITES.ETAPE.DEUX.MODEL' : 'CATEGORIES.ACTUALITES.ETAPE.DEUX.ACTUALITE') | translate }}</span>
        </li>
        <li class="galec-etapier__item {{activeClass(3)}}">
            <span class="galec-etapier__number">3</span>
            <span class="galec-etapier__titre">{{ 'CATEGORIES.ACTUALITES.ETAPE.TROIS' | translate }}</span>
        </li>
        <li *ngIf="isCentral" class="galec-etapier__item {{activeClass(4)}}">
            <span class="galec-etapier__number">4</span>
            <span class="galec-etapier__titre">{{ 'CATEGORIES.ACTUALITES.ETAPE.QUATRE' | translate }}</span>
        </li>
    </ul>
    <div *ngIf="loading">
        <mat-spinner></mat-spinner>
    </div>
    <div *ngIf="!loading">
        <form [formGroup]="form" class="form-step">
            <div *ngIf="step === 1">
                <div class="c-card__infos">{{ 'CATEGORIES.ACTUALITES.CHOISIR_FORMAT' | translate }}</div>
                <div class="c-create-news__format">
                    <div class="c-create-news__format--new">
                        <div class="c-create-news__title">{{ 'UTILS.NOUVEAU' | translate }}</div>
                        <div class="c-create-news__desc">{{ 'CATEGORIES.ACTUALITES.CREER_AZ' | translate }}</div>
                        <!-- Slider desktop only -->
                        <div class="d-none d-md-block">
                            <ul class="c-create-news__list c-slider__content">
                                <ng-container *ngFor="let type of types | keyvalue: sort">
                                    <li (click)="setFormat(type.key)"
                                        class="c-create-news__list--item {{format.typeActualite === type.key ? 'selected' : null}}">
                                        <div><img alt="" src="{{type.value.image}}"/></div>
                                        <span> {{ type.value.label | translate }}</span>
                                    </li>
                                </ng-container>
                            </ul>
                        </div>
                        <!-- Slider mobile only -->
                        <div class="c-slider--all d-md-none position-relative overflow-hidden">
                            <button (click)="owlCarTypes.prev()" class="c-slider__btn--prev" type="button"><i
                                    class="icon-fleche_gauche"></i></button>
                            <button (click)="owlCarTypes.next()" class="c-slider__btn--next" type="button"><i
                                    class="icon-fleche_droite"></i></button>
                            <owl-carousel-o #owlCarTypes [options]="typeSliderConfig"
                                            class="c-create-news__list c-slider__content">
                                <ng-template *ngFor="let type of types | keyvalue: sort" carouselSlide>
                                    <div (click)="setFormat(type.key)"
                                         class="c-create-news__list--item {{format.typeActualite === type.key ? 'selected' : null}}">
                                        <div>
                                            <img alt="" src="{{type.value.image}}"/>
                                        </div>
                                        <span> {{ type.value.label }}</span>
                                    </div>
                                </ng-template>
                            </owl-carousel-o>
                        </div>
                    </div>
                    <div *ngIf="!isModel && models?.size > 0" class="c-create-news__format--template">
                        <div>
                            <div class="c-create-news__title">{{ 'CATEGORIES.ACTUALITES.EN_LIGNE.PLURIEL' | translate }}</div>
                            <div class="c-create-news__desc">{{ 'CATEGORIES.ACTUALITES.CREER_EXISTANT' | translate }}</div>
                            <div class="c-slider--all">
                                <!-- Slider mobile only -->
                                <div class="position-relative overflow-hidden {{models.size > 3 ? 'show-navigation': ''}}">
                                    <button (click)="owlCarModelMobile.prev()" class="c-slider__btn--prev"
                                            type="button">
                                        <i class="icon-fleche_gauche"></i>
                                    </button>
                                    <button (click)="owlCarModelMobile.next()" class="c-slider__btn--next"
                                            type="button">
                                        <i class="icon-fleche_droite"></i>
                                    </button>
                                    <owl-carousel-o #owlCarModelMobile
                                                    [options]="modelSliderConfig"
                                                    class="c-create-news__list c-slider__content">
                                        <ng-template *ngFor="let model of models | keyvalue: sort" carouselSlide>
                                            <div (click)="setFormat(model.value, true)"
                                                 class="c-create-news__list--item {{format.modelActualite == model.value.id_actualite ? 'selected' : null}}">
                                                <div class="position-relative">
                                                    <galec-actualite-thumbnail [actualite]="model.value"
                                                                               [showTitle]="true"></galec-actualite-thumbnail>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </owl-carousel-o>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectTypeOrModel" class="c-asterisk">
                    * {{ 'CATEGORIES.ACTUALITES.SELECTIONNER_MODELE' | translate }}
                </div>
                <div class="c-create-news__btn mt-lg-4">
                    <button (click)="goBack()" class="c-btn c-create-news__btn--quit c-btn--blue" type="button">
                        {{ 'UTILS.QUITTER' | translate }}
                    </button>
                    <button (click)="next()" class="c-btn c-create-news__btn--next ml-lg-4" type="button">
                        {{ 'UTILS.SUIVANT' | translate }}
                        <i class="icon-fleche_droite"></i>
                    </button>
                </div>
            </div>
            <div *ngIf="step === 2">
                <div *ngIf="!isModel" class="c-create-news__dates d-inline mt-4">
                    <div class="row mt-4">
                        <div class="col-2">
                            <div class="  {{edit?.id_actualite>0 && !edit.draft ? 'disabled' : null}}">
                                <label class="c-card__small-title"
                                       for="date_debut">{{ 'CATEGORIES.ACTUALITES.DATE.DEBUT' | translate }}<sup>*</sup></label>
                                <div class="date-picker-start date-picker" controlErrorContainer>
                                    <input [matDatepickerFilter]="filterMaxActualiteByPeriod"
                                           [matDatepicker]="date_debut"
                                           class="c-btn galec-calendar mt-2 w-100 {{edit?.id_actualite>0 && !edit.draft ? 'disabled' : null}}"
                                           formControlName="date_debut"
                                           id="date_debut" matInput>
                                    <mat-datepicker-toggle [for]="date_debut" class="button-calendar" matSuffix>
                                        <i class="icon-calendrier" matDatepickerToggleIcon></i>
                                    </mat-datepicker-toggle>
                                    <mat-datepicker
                                        #date_debut
                                        [disabled]="edit.id_actualite>0 && !edit.draft"
                                        class="position-relative p-0"
                                        [startAt]="getNextAvailableDate()"
                                    ></mat-datepicker>
                                </div>
                            </div>

                        </div>
                        <div class="col-2">
                            <div class="c-create-news__dates--start-hour mt-3 mt-lg-0">
                                <label class="c-card__small-title"
                                       for="heure_debut">{{ 'CATEGORIES.ACTUALITES.HEURE.DEBUT' | translate }}
                                    <sup>*</sup></label>
                                <div class="ngx-timepicker-field-example timepicker__wrapper" controlErrorContainer>
                                    <app-timepicker (timeSet)="setTime()" [control]="getControl('heure_debut')"
                                                    id="heure_debut"></app-timepicker>
                                </div>
                            </div>
                        </div>
                        <div class="col-2">
                            <div class="mt-lg-0">
                                <label class="c-card__small-title"
                                       for="date_fin">{{ 'CATEGORIES.ACTUALITES.DATE.FIN' | translate }}</label>
                                <div class="date-picker-end date-picker" controlErrorContainer>
                                    <input [matDatepickerFilter]="filterMaxActualiteByPeriod" [matDatepicker]="date_fin"
                                           class="c-btn galec-calendar mt-2 w-100 {{edit?.id_actualite>0 && !edit.draft ? 'disabled' : null}}"
                                           formControlName="date_fin"
                                           id="date_fin" matInput>
                                    <mat-datepicker-toggle [for]="date_fin" class="button-calendar" matSuffix>
                                        <i class="icon-calendrier" matDatepickerToggleIcon></i>
                                    </mat-datepicker-toggle>
                                    <mat-datepicker
                                        #date_fin
                                        disabled="false"
                                        [startAt]="getNextAvailableDate()"
                                    ></mat-datepicker>
                                    <i (click)="clearDate('date_fin')" *ngIf="form.value.date_fin"
                                       class="icon-fermer"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-2">
                            <div class="c-create-news__dates--start-hour mt-3 mt-lg-0">
                                <label class="c-card__small-title"
                                       for="heure_fin">{{ 'CATEGORIES.ACTUALITES.HEURE.FIN' | translate }}</label>
                                <div class="ngx-timepicker-field-example timepicker__wrapper" controlErrorContainer>
                                    <app-timepicker (timeSet)="setTime()" [control]="getControl('heure_fin')"
                                                    id="heure_fin"></app-timepicker>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <p class="msg-help">{{ 'CATEGORIES.ACTUALITES.MESSAGE_MAX_ACTU' | translate }}
                                ({{ MAX_ITEMS }})</p>
                        </div>
                    </div>

                </div>

                <div *ngIf="!isModel && !isCentral">
                    <div class="c-title mt-5">{{ 'CATEGORIES.ACTUALITES.CONCERNES_PAR_ACTU' | translate }}</div>
                    <div class="c-form">
                        <div class="row">
                            <ul class="col c-form__check--item mt-2" controlErrorContainer formGroupName="express">
                                <li *ngFor="let pv of pointVentesOptions; let i=index"
                                    class="col-12 col-lg-3 c-form__check--item">
                                    <input (click)="expressChecked($event, pv)"
                                           formControlName="{{pv.id_pointvente}}"
                                           id="concept-{{pv.id_pointvente}}"
                                           type="checkbox">
                                    <label #tooltip="matTooltip" [matTooltipPosition]="'below'"
                                           aria-describedby="label" for="concept-{{pv.id_pointvente}}"
                                           matTooltip="{{pv.activitecommerciale.libelle }} ({{ pv.Triptych }})"
                                           matTooltipClass="galec-tooltip">
                                        @if (ActiviteActualiteUtils.isHyperOrSuper(pv.code_activite)) {
                                            {{ 'CATEGORIES.ACTUALITES.HYPER_SUPER' | translate }}
                                        } @else {
                                            {{ pv.libelle }}
                                        }
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="c-card__infos mb-3">
                    {{ 'CATEGORIES.ACTUALITES.CLIQUER_MODIFIER' | translate }} :
                </div>
                <div class="form-group">
                    <input class="form-control"
                           formControlName="titre"
                           placeholder="{{ 'CATEGORIES.ACTUALITES.TITRE_ACTU.MESSAGE' | translate }} {{ (this.format?.type === 'image') ? '(' + ('CATEGORIES.ACTUALITES.TITRE_ACTU.OPTIONNEL' | translate) + ')' : '' }}"
                           type="text">
                </div>
                <div *ngIf="format.type !== 'text'" class="form-group">
                    <input class="form-control" formControlName="lien" id="lien"
                           placeholder="{{ 'CATEGORIES.ACTUALITES.LIEN_IMAGE' | translate }}" type="text">
                </div>
                <div class="c-create-news__content">
                    <div (click)="showImage()" *ngIf="format.type !== 'text'"
                         class="{{format.type === 'textImage' ? 'c-create-news__content--left-zone' : (form.value.imageBase64 ? null: 'c-create-news__content--full-img-zone')}}">
                        <div controlErrorContainer>
                            <label *ngIf="!form.value.image" class="label-file">
                                <span>{{ 'CATEGORIES.ACTUALITES.UPLOAD_IMAGE.MESSAGE' | translate }}
                                    <br/>{{
                                        'CATEGORIES.ACTUALITES.UPLOAD_IMAGE.TAILLE' | translate: {
                                            width: actualiteImage.width,
                                            height: actualiteImage.height,
                                            weight: 4
                                        }
                                    }}</span>
                                <i class="icon-img"></i>
                            </label>
                            <img *ngIf="form.controls.imageBase64.value" [src]="form.controls.imageBase64.value"
                                 class="img-actualite">
                            <textarea class="d-none" formControlName="image" id="image"></textarea>
                        </div>
                    </div>
                    <div *ngIf="format.type !== 'image'"
                         class="{{format.type === 'textImage' ? 'c-create-news__content--right-zone' : 'c-create-news__content--full-txt-zone'}}">
                        <quill-editor (onEditorCreated)="getEditorInstance($event)" class="quill-input"
                                      customToolbarPosition="bottom"
                                      formControlName="texte" format="html"
                                      placeholder="{{ 'CATEGORIES.ACTUALITES.AJOUT_TEXTE' | translate }}"
                                      theme="bubble">
                            <div quill-editor-toolbar>
                                                                        <span class="ql-formats">
                                                                            <button class="ql-bold"></button>
                                                                            <button class="ql-italic"></button>
                                                                            <button class="ql-link"></button>
                                                                        </span>
                            </div>
                        </quill-editor>
                    </div>
                </div>
                <div *ngIf="format.type !== 'text'" class="form-group input-image-alt">
                    <input class="form-control" [ngClass]="{'edit': edit.image_alt}" formControlName="image_alt" id="description"
                           placeholder="{{ 'CATEGORIES.ACTUALITES.PLACEHOLDER_BALISE_ALT' | translate }}" type="text">
                    @if (edit.image_alt) {
                        <button (click)="revertImageAlt()" class="c-btn btn-revert-alt" type="button">
                            {{ 'CATEGORIES.ACTUALITES.RECUPERER_ALT' | translate }}
                        </button>
                    }
                </div>

                <div class="c-create-news__btn mt-3 mt-lg-4">
                    <button (click)="goBack()" *ngIf="edit.id_actualite"
                            class="c-btn c-create-news__btn--quit c-btn--blue" type="button">
                        {{ 'UTILS.QUITTER' | translate }}
                    </button>
                    <button (click)="previous()" *ngIf="!edit.id_actualite"
                            class="c-btn c-create-news__btn--prev picto-first" type="button">
                        <i class="icon-fleche_gauche"></i>
                        <span>{{ 'UTILS.PRECEDENT' | translate }}</span>
                    </button>
                    <button (click)="next()" class="c-btn c-create-news__btn--next ml-lg-4" type="submit">
                        {{ 'UTILS.SUIVANT' | translate }}
                        <i class="icon-fleche_droite"></i>
                    </button>
                </div>
            </div>
            <div *ngIf="step === 3">
                <div class="c-card__infos">{{ 'CATEGORIES.ACTUALITES.DERNIERE_VERIF' | translate }}</div>
                <h2 class="c-create-news__title">{{ form.value.titre }}</h2>
                <div class="c-create-news__content">
                    <div *ngIf="format.type !== 'text'"
                         class="{{format.type === 'textImage' ? 'c-create-news__content--left-zone' : null}}">
                        <a *ngIf="form.value.lien" href="{{form.value.lien}}">
                            <img *ngIf="form.value.imageBase64" alt="" class="img-actualite"
                                 src="{{form.value.imageBase64}}">
                        </a>
                        <img *ngIf="!form.value.lien" alt="" class="img-actualite" src="{{form.value.imageBase64}}">
                    </div>
                    <div *ngIf="format.type !== 'image'"
                         class="{{format.type === 'textImage' ? 'c-create-news__content--right-zone' : 'c-create-news__content--full-txt-zone'}}">
                        <div [innerHTML]="form.value.texte"></div>
                    </div>
                </div>
                <div class="c-create-news__btn mt-3 mt-lg-4">
                    <button (click)="previous()" class="c-btn c-create-news__btn--prev picto-first" type="button">
                        <i class="icon-fleche_gauche"></i>
                        <span>{{ 'UTILS.PRECEDENT' | translate }}</span>
                    </button>
                    <button (click)="submit()" *ngIf="!isCentral" class="c-btn c-create-news__btn--next ml-lg-4"
                            type="submit">
                        {{ 'UTILS.CONFIRMER' | translate }}
                        <i class="icon-fleche_droite"></i>
                    </button>
                    <button (click)="next()" *ngIf="isCentral" class="c-btn c-create-news__btn--next ml-lg-4"
                            type="submit">
                        {{ 'UTILS.SUIVANT' | translate }}
                        <i class="icon-fleche_droite"></i>
                    </button>
                </div>
            </div>
            <div *ngIf="step === 4 && isCentral">
                <div class="c-card__infos">{{ 'CATEGORIES.ACTUALITES.HYPER_SUPER_CONCERNES' | translate }}</div>
                <div class="mt-3">
                    <div class="c-form">
                        <div class="row">
                            <div class="col-12 col-lg-3 mt-2 c-form__check--item">
                                <input (click)="checkAll($event)" formControlName="Allconcepts" id="Allconcepts"
                                       type="checkbox">
                                <label aria-describedby="label"
                                       for="Allconcepts">{{ 'CATEGORIES.ACTUALITES.TOUS_HYPER_SUPER' | translate }}</label>
                            </div>
                        </div>
                        <div formGroupName="pointventes">
                            <ul class="row c-form__check mt-2" controlErrorContainer>
                                <li *ngFor="let pointVente of pointVentes; let i=index"
                                    class="col-12 col-lg-3 c-form__check--item">
                                    <input (click)="conceptChecked($event)" formControlName="{{pointVente.id_pointvente}}"
                                           id="concept-{{pointVente.id_pointvente}}" type="checkbox">
                                    <label #tooltip="matTooltip" [matTooltipPosition]="'below'" aria-describedby="label"
                                           for="concept-{{pointVente.id_pointvente}}"
                                           matTooltip="{{pointVente.activitecommerciale.libelle }} ({{ pointVente.Triptych }})"
                                           matTooltipClass="galec-tooltip">
                                        {{ pointVente.libelle }}
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="c-create-news__btn mt-3 mt-lg-4">
                    <button (click)="previous()" class="c-btn c-create-news__btn--prev picto-first" type="button">
                        <i class="icon-fleche_gauche"></i>
                        <span>{{ 'UTILS.PRECEDENT' | translate }}</span>
                    </button>
                    <button (click)="submit()" class="c-btn c-create-news__btn--next ml-lg-4" type="submit">
                        {{ 'UTILS.CONFIRMER' | translate }}
                        <i class="icon-fleche_droite"></i>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>

<div *ngIf="finish" class="c-card c-card--notitle c-create-news">
    <div class="c-card__title mb-4">{{ 'UTILS.CONFIRMATION' | translate }}</div>

    <div class="c-create-news__confirm">
        <i class="icon-valider"></i>
        <p *ngIf="!recap.draft">
            <span *ngIf="edit.id_actualite">{{ 'CATEGORIES.ACTUALITES.MODIF_VALIDER' | translate }}</span>
            <span *ngIf="!edit.id_actualite">
                {{ ((this.isModel) ? 'CATEGORIES.ACTUALITES.CONFIRM_SAISI.MODELE' : 'CATEGORIES.ACTUALITES.CONFIRM_SAISI.ACTUALITE') | translate }}
                « {{ recap.title }} ».<br/>
                <span *ngIf="recap.date">{{
                        'CATEGORIES.ACTUALITES.DATE_VISIBLE' | translate: {
                            date: recap.date,
                            heure: recap.time
                        }
                    }}</span>
            </span>
        </p>
        <p *ngIf="recap.draft">
            {{ 'CATEGORIES.ACTUALITES.ACTUALITE_ENREGISTREE_BROUILLON' | translate: {title: recap.title} }}
        </p>
    </div>

    <div class="c-create-news__btn--confirm  mt-lg-4">
        <div>
            <a [routerLink]="['/' + currentLang + '/app/home']" class="c-btn c-btn--blue" title="">
                {{ 'CATEGORIES.ACTUALITES.ALLER_ACCUEIL' | translate }}
            </a>
            <button (click)="goBack()" class="c-btn ml-lg-4" title="">
                {{ ((this.isModel) ? 'CATEGORIES.ACTUALITES.VOIR.MODELE' : 'CATEGORIES.ACTUALITES.VOIR.ACTUALITE') | translate }}
            </button>
        </div>
    </div>

</div>
